import { Main } from './main';

export function Widget() {
  return <Main />;
}
